import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const InfoTooltip = ({ text }) => {
  return (
    <Tooltip 
      title={text} 
      placement="top"
      arrow
      sx={{ ml: 0.5 }}
    >
      <IconButton size="small" sx={{ p: 0.25 }}>
        <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
      </IconButton>
    </Tooltip>
  );
};

export default InfoTooltip;